import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchBuildingforecast } from './buildingforecastAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchBuildingforecastDataWithFilters = createAsyncThunk(
  'Buildingforecast/fetchBuildingforecastDataWithFilters',
  async ({ filter = {}, options = {} }) => {    
    const response = await fetchBuildingforecast({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const buildingforecastSlice = createSlice({
  name: 'buildingforecast',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuildingforecastDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchBuildingforecastDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchBuildingforecastDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectBuildingforecastData = (state) => state.buildingforecast.data;
export const selectBuildingforecastStatus = (state) => state.buildingforecast.status;
export const selectBuildingforecastError = (state) => state.buildingforecast.error;

export default buildingforecastSlice.reducer;
